// extracted by mini-css-extract-plugin
export default {"page":"RegistrationPage_page__e0MIf"};